import { render, staticRenderFns } from "./DashTable.vue?vue&type=template&id=633b19de"
import script from "./DashTable.vue?vue&type=script&lang=js"
export * from "./DashTable.vue?vue&type=script&lang=js"
import style0 from "./DashTable.vue?vue&type=style&index=0&id=633b19de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports